// extracted by mini-css-extract-plugin
export default {"line":"AreaListItem_line__KTE15","fio":"AreaListItem_fio__lJjBM"};